// Generated by OrchestKit Claude Plugin
// Created: 2026-09-24

import { formaterFcfa } from '../../composants/ui/index.ts';
import type { ClientEncours } from '../clients/types.ts';

/**
 * Port de `DepotClientWeb.peutPrendreCredit` (mobile) — client inactif,
 * plafond nul, ou plafond dépassé. `null` = crédit autorisé.
 *
 * Retour immédiat côté client ; le serveur refait ce contrôle et reste seul
 * juge (RG-087, RG-088, plafond global toutes boutiques confondues).
 */
export function verdictCredit(client: ClientEncours, montant: number): string | null {
  if (!client.actif) {
    return 'Ce client est désactivé : impossible de lui accorder un crédit.';
  }
  if (client.plafond_credit === 0) {
    return 'Ce client n’a aucun plafond de crédit.';
  }
  if (client.plafond_credit === null) {
    return null;
  }
  const disponible = Math.max(0, client.plafond_credit - client.encours);
  if (montant > disponible) {
    return `Plafond dépassé : ${client.prenom ?? ''} ${client.nom} ne peut prendre que ${formaterFcfa(disponible)} de plus à crédit.`.trim();
  }
  return null;
}
